import React from 'react';
import { number, string } from 'prop-types';

const IconDistribute = ({ size = 24, fill = '#30435D' }) => {
  return (
    <svg data-test="icondistribute" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 10L1.51 3L22.5 12L1.51 21L1.5 14L16.5 12L1.5 10ZM3.51 6.03L11.02 9.25L3.5 8.25L3.51 6.03ZM11.01 14.75L3.5 17.97V15.75L11.01 14.75Z"
        fill={fill}
      />
    </svg>
  );
};

IconDistribute.propTypes = {
  size: number,
  fill: string,
};

export default IconDistribute;
